if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        try {
          const currentVariant = currentProduct.variants.find(
            (_item) => _item.id == variantId
          );
          const isGlass = currentVariant.title.includes("Glass");
          const tinSelectGroup = document.querySelector(".tin-select-group");
          const glassSelectGroup = document.querySelector(
            ".glass-select-group"
          );
          const discountElements = document.querySelectorAll(".discount-rate");
          if (isGlass) {
            glassSelectGroup.classList.add("active-group");
            glassSelectGroup.classList.remove("visual-hidden");
            tinSelectGroup.classList.remove("active-group");
            tinSelectGroup.classList.add("visual-hidden");

            discountElements.forEach((_element) => {
              _element.textContent = "15%";
            });
          } else {
            tinSelectGroup.classList.add("active-group");
            tinSelectGroup.classList.remove("visual-hidden");
            glassSelectGroup.classList.remove("active-group");
            glassSelectGroup.classList.add("visual-hidden");

            discountElements.forEach((_element) => {
              _element.textContent = "10%";
            });
          }
        } catch (_err) {
          console.log("Error at bundle widget", _err);
        }

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        console.log("on click refresh list");
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        console.log("on render error");
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer")
        );

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pickup-availability-drawer")
              .show(evt.target);
          });
      }
    }
  );
}

const addToCartBtn = document.querySelector(".bundle-to-cart");
const parser = new DOMParser();
if (addToCartBtn) {
  const cartDrawerTrigger = document.querySelector("#cart-icon-bubble");
  addToCartBtn.addEventListener("click", function () {
    const activeGroup = document.querySelector(".select-group.active-group");
    const selectElements = activeGroup.querySelectorAll("select");
    const isTin = activeGroup.classList.contains("tin-select-group");

    const items = [
      {
        id: isTin ? 45812905672978 : 45794954019090,
        quantity: 1,
        properties: {
          "Candle 1": "",
          "Candle 2": "",
          "Candle 3": "",
          "Scent #1": selectElements[0].value,
          "Scent #2": selectElements[1].value,
          "Scent #3": selectElements[2].value,
          _bundle_selection: `${selectElements[0].value} <> ${selectElements[1].value} <> ${selectElements[2].value}`,
        },
      },
    ];

    const isNotSelected =
      selectElements[0]?.value == "" ||
      selectElements[1]?.value == "" ||
      selectElements[2]?.vallue == "";
    console.log(selectElements, isNotSelected);

    if (isNotSelected) {
      const alertDiv = document.createElement("div");
      alertDiv.textContent = "Please select a scent for all options";
      alertDiv.style.position = "fixed";
      alertDiv.style.top = "20px";
      alertDiv.style.left = "50%";
      alertDiv.style.transform = "translateX(-50%)";
      alertDiv.style.backgroundColor = "#ff4444";
      alertDiv.style.color = "white";
      alertDiv.style.padding = "10px 20px";
      alertDiv.style.borderRadius = "5px";
      alertDiv.style.zIndex = "9999";
      alertDiv.style.boxShadow = "0 2px 10px rgba(0,0,0,0.2)";
      document.body.appendChild(alertDiv);

      // Remove after 3 seconds
      setTimeout(() => {
        document.body.removeChild(alertDiv);
      }, 3000);
      return false;
    }
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = "Adding to Cart...";

    fetch("https://www.wickguru.com/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then((response) => response.json())
      .then((_data) => {
        /**
         * * can add a logic to check if _data's items' discount has trio discount
         */
        fetch("https://www.wickguru.com/?section_id=cart-drawer")
          .then((response) => response.text())
          .then((carthtml) => {
            const parsedCartHtml = parser.parseFromString(
              carthtml,
              "text/html"
            );
            const newCartDrawer = parsedCartHtml.querySelector("cart-drawer");
            const jsContentElement = newCartDrawer.querySelector(
              ".cart-drawer__footer"
            );
            if (jsContentElement) {
              const discountMessage = document.createElement("div");
              discountMessage.className =
                "discount-custom-message tax-note caption-large rte";
              discountMessage.innerHTML = `👏 Ooo nice! You just saved ${
                isTin ? 10 : 15
              }% by grabbing 3 ${isTin ? "tin" : "glass"} candles!`;
              jsContentElement.appendChild(discountMessage);
            }
            const currentCartDrawer = document.querySelector("cart-drawer");

            if (currentCartDrawer) {
              currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
              const newClasses = newCartDrawer.classList;
              currentCartDrawer.className = "";
              newClasses.forEach((_class) => {
                currentCartDrawer.classList.add(_class);
              });

              const keyEvent = {
                key: " ", // The key value for the SPACE key
                keyCode: 32, // The keyCode for the SPACE key
                code: "Space", // The physical key on the keyboard
                which: 32, // Same as keyCode (deprecated but included for completeness)
                location: 0, // 0: Standard key location
                repeat: false, // Whether the key is being held down
                isComposing: false, // Whether the event is part of a composition session
                bubbles: true, // The event bubbles up through the DOM
                cancelable: true, // The event can be canceled
                shiftKey: false, // Shift key is not pressed
                ctrlKey: false, // Ctrl key is not pressed
                altKey: false, // Alt key is not pressed
                metaKey: false, // Meta key (e.g., Command on Mac) is not pressed
              };
              if (cartDrawerTrigger) {
                const spaceKeyEvent = new KeyboardEvent("keydown", keyEvent);
                const spaceKeyEvent1 = new KeyboardEvent("keyup", keyEvent);

                cartDrawerTrigger.dispatchEvent(spaceKeyEvent);
                cartDrawerTrigger.dispatchEvent(spaceKeyEvent1);
              } else {
                console.log("Cart icon bubble element not found.");
              }
            }
          });
      })
      .catch((error) => {
        console.log("Error:", error);
      })
      .finally(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "Create My Trio";
      });
  });
}

/**
 * * left time until delivery logic
 */
function formatDeliveryDate(_date) {
  const options = { weekday: "long", day: "numeric", month: "long" };
  return new Date(_date).toLocaleDateString("en-US", options);
}
function getNextDeliveryDate() {
  const now = new Date();
  const cutoffHour = 14;
  let deliveryDate = new Date(now);
  deliveryDate.setDate(deliveryDate.getDate() + 1);
  let cutoffTime = new Date(now);
  cutoffTime.setHours(cutoffHour, 0, 0, 0);
  if (now.getHours() >= cutoffHour) {
    cutoffTime.setDate(cutoffTime.getDate() + 1);
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }
  const difference = cutoffTime - now;
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const remainingTime =
    days == 0 && hours == 0 && minutes == 0
      ? "NOW"
      : `${days > 0 ? `${days} DAYS ` : ""}${
          hours > 0 ? `${hours} HOURS ` : ""
        }${minutes} MINUTES`;

  return [deliveryDate, remainingTime];
}

document.addEventListener("DOMContentLoaded", function () {
  const deliveryDateElem = document.querySelector(
    ".show-time--label .delivery-time"
  );
  const remainingTimeElem = document.querySelector(
    ".show-time--label .delivery-difference-time"
  );
  if (deliveryDateElem && remainingTimeElem) {
    const [deliveryDate, remainingTime] = getNextDeliveryDate();
    deliveryDateElem.textContent = `Want It By ${formatDeliveryDate(
      deliveryDate
    )}?`;
    remainingTimeElem.textContent = `${remainingTime}`;
  }

  function updateDeliveryTime() {
    const [, remainingTime] = getNextDeliveryDate();
    if (remainingTimeElem) {
      remainingTimeElem.textContent = `${remainingTime}`;
    }
  }

  setInterval(updateDeliveryTime, 60000);

  /**
   * * handler for variant option changed case in product page
   */
  function handleVariantOptionChanged(event) {
    const selectedValue = event.target.value;
    // const optionName = event.target.name || event.target.getAttribute("name");

    const currentVariantWithQuantity = productVariants.find(
      (_item) => _item.title == selectedValue
    );

    let _quantity = currentVariantWithQuantity.available
      ? currentVariantWithQuantity.quantity
      : 0;
    const currentQuantity = parseInt(
      document.querySelector(".custom-para .quantity__input")?.value ?? "0"
    );
    const leftLabel = document.querySelector(".left-quantity--label");
    if (!leftLabel) {
    } else if (_quantity == 0) leftLabel.textContent = "Out of stock";
    else if (_quantity < currentQuantity) {
      document.querySelector(".custom-para .quantity__input").value = 1;

      if (_quantity - 1 < 20)
        leftLabel.textContent = `${_quantity - 1} left in stock`;
    } else if (_quantity - currentQuantity < 20) {
      leftLabel.textContent = `${_quantity - currentQuantity} left in stock`;
    } else {
      leftLabel.textContent = "";
    }
  }

  function handleBundleTypeOptionChanged(event) {
    const selectedValue = event.target.value;
    const isGlass = selectedValue.includes("Glass");
    const bundlePrice = isGlass ? bundlePriceList[0] : bundlePriceList[1];

    const tinSelectGroup = document.querySelector(".tin-select-group");
    const glassSelectGroup = document.querySelector(".glass-select-group");
    const discountElements = document.querySelectorAll(".discount-rate");
    const bundlePriceElement = document.querySelector(".bundle-price-span");
    if (isGlass) {
      glassSelectGroup.classList.add("active-group");
      glassSelectGroup.classList.remove("visual-hidden");
      tinSelectGroup.classList.remove("active-group");
      tinSelectGroup.classList.add("visual-hidden");

      discountElements.forEach((_element) => {
        _element.textContent = "15%";
      });

      if (bundlePriceElement) bundlePriceElement.textContent = bundlePrice;
    } else {
      tinSelectGroup.classList.add("active-group");
      tinSelectGroup.classList.remove("visual-hidden");
      glassSelectGroup.classList.remove("active-group");
      glassSelectGroup.classList.add("visual-hidden");

      discountElements.forEach((_element) => {
        _element.textContent = "10%";
      });

      if (bundlePriceElement) bundlePriceElement.textContent = bundlePrice;
    }
  }

  if (isBundle) {
    const radioButtons = document.querySelectorAll(
      'variant-radios input[type="radio"]'
    );
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", handleVariantOptionChanged);
    });
    const selectElements = document.querySelectorAll("variant-selects select");
    selectElements.forEach((select) => {
      select.addEventListener("change", handleVariantOptionChanged);
    });
  } else {
    const bundleRadioButtons = document.querySelectorAll(
      'variant-radios.bundle-type-selector input[type="radio"]'
    );

    bundleRadioButtons.forEach((radio) => {
      radio.addEventListener("change", handleBundleTypeOptionChanged);
    });

    const bundlePriceElement = document.querySelector(".bundle-price-span");
    if (bundlePriceElement) bundlePriceElement.textContent = bundlePriceList[0];
  }
});

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        console.log("this is clicked:", target);
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
      }
    }
  );
}
